import { MODAL_TYPES } from '../../../common/constants'

export const getModalPayloads = (props) => {
    const { modalType, selectedTableRows, params, columns } = props
    const { DELETE_MODAL, OFFER_BASE_MODAL, EXPORT_DATA_MODAL, CHANGE_AGENT_MODAL } = MODAL_TYPES

    // add other modal payloads as needed
    switch (modalType) {
        case DELETE_MODAL:
            return {
                modalType: DELETE_MODAL,
                modalProps: {
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    callbackId: 'delete-projects',
                    appModule: 'project',
                },
            }
        case OFFER_BASE_MODAL:
            return {
                modalType: OFFER_BASE_MODAL,
                modalProps: {
                    items: selectedTableRows,
                    offerType: 'project',
                },
            }
        case EXPORT_DATA_MODAL:
            return {
                modalType: EXPORT_DATA_MODAL,
                modalProps: {
                    params,
                    tableColumns: columns,
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    appModule: 'project',
                },
            }
        case CHANGE_AGENT_MODAL:
            return {
                modalType: CHANGE_AGENT_MODAL,
                modalProps: {
                    modalData: selectedTableRows.map((row) => ({
                        id: row.id,
                        internalAppId: row.internalAppId,
                        city: row.city?.name,
                        agentFirstName: row.agentFirstName,
                        agentLastName: row.agentLastName,
                    })),
                },
            }
        default:
            return null
    }
}
